import { render } from "./StudentFinanceData.vue?vue&type=template&id=421e7afe&scoped=true"
import script from "./StudentFinanceData.vue?vue&type=script&lang=js"
export * from "./StudentFinanceData.vue?vue&type=script&lang=js"

import "./StudentFinanceData.vue?vue&type=style&index=0&id=421e7afe&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/embody-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-421e7afe"]])

export default __exports__